import { NavLink, Outlet, Link } from "react-router-dom";
import { Disc3, ShieldCheck } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", id: "nav-home", end: true, hideMobile: true },
  { to: "/joiners", label: "Joiners", id: "nav-joiners" },
  { to: "/drops", label: "Open Drops", id: "nav-drops" },
  { to: "/higher", label: "Higher Store Claims", short: "Higher", id: "nav-higher" },
];

const linkCls = ({ isActive }) =>
  `px-2 sm:px-3 py-1.5 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
    isActive ? "bg-white text-zinc-950" : "text-zinc-400 hover:text-white hover:bg-white/5"
  }`;

export default function Layout() {
  return (
    <div className="grain relative min-h-screen bg-[#09090b] text-zinc-100">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-zinc-950/75 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center gap-2 sm:gap-4">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-2 mr-auto group">
            <span className="h-8 w-8 rounded-lg bg-gradient-to-br from-pink-500 to-violet-600 grid place-items-center transition-transform duration-500 group-hover:rotate-180">
              <Disc3 className="h-4 w-4 text-white" />
            </span>
            <span className="hidden sm:inline font-display font-extrabold tracking-tight text-lg">PastelAreku GOs</span>
          </Link>
          <nav className="flex items-center gap-0.5 sm:gap-1 overflow-x-auto">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={(s) => `${linkCls(s)} ${n.hideMobile ? "hidden sm:inline-flex" : ""}`} data-testid={n.id}>
                {n.short ? <><span className="sm:hidden">{n.short}</span><span className="hidden sm:inline">{n.label}</span></> : n.label}
              </NavLink>
            ))}
            <NavLink
              to="/admin"
              data-testid="nav-admin"
              className={({ isActive }) =>
                `ml-1 inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap border transition-colors duration-200 ${
                  isActive ? "bg-white text-zinc-950 border-white" : "border-violet-500/40 bg-violet-500/10 text-violet-200 hover:bg-violet-500/20"
                }`
              }
            >
              <ShieldCheck className="hidden sm:block h-4 w-4" /> Admin
            </NavLink>
          </nav>
        </div>
      </header>
      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
        <Outlet />
      </main>
    </div>
  );
}
